import { Layout } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import Footer from '~/pages/backoffice/Footer';
import Header from '~/pages/backoffice/Header';
import NavBar from '~/pages/backoffice/NavBar';

const { Content } = Layout;

type IProps = {
  children: ReactNode;
};

function BackOfficeLayout({ children }: IProps) {
  return (
    <>
      <Layout style={{ minHeight: '100%', width: 'auto' }}>
        <NavBar />
        <Layout style={{ backgroundColor: '#fff' }}>
          <SContent>
            <Header />
            {children}
          </SContent>
          <Footer />
        </Layout>
      </Layout>
    </>
  );
}

export default BackOfficeLayout;

const SContent = styled(Content)`
  padding: 20px 20px 10px 20px;
`;
